import type {SelectItem, SingleSelectAttrs} from '@jetbrains/ring-ui/components/select/select'
import Select from '@jetbrains/ring-ui/components/select/select'
import * as React from 'react'

import {SORT_ALFABETICALLY, SORT_ENABLED_FIRST, SORT_RUNNING_FIRST} from '../../AgentsPages.utils'

type CustomOption = {value: string}

const SORTING_SELECT_OPTIONS: SelectItem<CustomOption>[] = [
  {key: SORT_ALFABETICALLY, value: SORT_ALFABETICALLY, label: 'Sort by agent name'},
  {key: SORT_ENABLED_FIRST, value: SORT_ENABLED_FIRST, label: 'Sort by enabled state'},
  {key: SORT_RUNNING_FIRST, value: SORT_RUNNING_FIRST, label: 'Sort by running build'},
]

export function useAgentsSortingSelectState() {
  return React.useState<SelectItem<CustomOption> | null>(SORTING_SELECT_OPTIONS[0])
}

export default function AgentsSortingSelect({
  selected,
  onChange,
  className,
}: {
  selected: SingleSelectAttrs<CustomOption>['selected']
  onChange: SingleSelectAttrs<CustomOption>['onChange']
  className: string
}) {
  return (
    <Select
      className={className}
      type={Select.Type.BUTTON}
      label={'Sort by '}
      data={SORTING_SELECT_OPTIONS}
      onChange={onChange}
      selected={selected}
    />
  )
}
